import L from "leaflet";
import "../../../../../node_modules/leaflet-measure/dist/leaflet-measure.it";
// import "leaflet-measure";
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import "../../../../../node_modules/leaflet-measure/dist/leaflet-measure.css";

function Measure(props) {
  const map = useMap();
  useEffect(() => {
    const control = L.control.measure({
      ...props,
    });

    map.addControl(control);

    return () => {
      map.removeControl(control);
    };
  }, [map, props]);

  return null;
}

export default Measure;
